export const STATO_IN_ATTESA = 1
export const STATO_IN_CARICO = 2
export const STATO_IN_PROGRAMMAZIONE = 3
export const STATO_LAVORI_IN_CORSO = 4
export const STATO_CHIUSA = 5

export const COLOR_STATO_IN_ATTESA = '#73797c'
export const COLOR_STATO_IN_CARICO = '#d6383b'
export const COLOR_STATO_IN_PROGRAMMAZIONE = '#e17539'
export const COLOR_STATO_LAVORI_IN_CORSO = '#bbbd3b'
export const COLOR_STATO_CHIUSA = '#70bf4d'

export const CATEGORIA_AMBIENTE = 1
export const CATEGORIA_SERVIZI_AL_CITTADINO = 2
export const CATEGORIA_SICUREZZA = 3
export const CATEGORIA_STRADE_E_VIABILITA = 4
export const CATEGORIA_VERDE_PUBBLICO = 5
export const CATEGORIA_TRIBUTI_E_CATASTO = 6

export const TIPOLOGIA_ANIMALI = 2
export const TIPOLOGIA_ACQUEDOTTO_E_FOGNATURE = 3
export const TIPOLOGIA_ALTRO = 1
export const TIPOLOGIA_ARREDO_URBANO = 4
export const TIPOLOGIA_BUCHE = 5
export const TIPOLOGIA_CARTELLONISTICA_PUBBLICITARIA = 6
export const TIPOLOGIA_DANNI_ESTESI_AL_MANTO = 7
export const TIPOLOGIA_ILLUMINAZIONE_E_SEMAFORI = 8
export const TIPOLOGIA_MARCIAPIEDE = 9
export const TIPOLOGIA_SEGNALETICA_E_VIABILITA = 10
export const TIPOLOGIA_RIFIUTI = 11
export const TIPOLOGIA_VERDE = 12
